import React, { Component } from "react"
import { connect } from "react-redux"
import { SaleAttributionService, GroupPositionUserService, buildTransaction, savePendingAttributions } from "../normalizer"
import { ToastService } from "../../Gamification2026Template/shared/Toast"

class PendingAttributionsContainer extends Component {
  state = {
    page: 1,
    isAttributionSelected: false,
    saleAttribution: undefined,
    users: [],
    selectedUser: undefined
  }

  handlePageChange = data => {
    this.setState({ page: data.selected + 1 }, () =>
      this.getPendingSaleAttributions()
    )
  }

  getPendingSaleAttributions() {
    const { user, campaign, filterFrom, filterTo, filterContract } = this.props

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      page: this.state.page,
      from: filterFrom || undefined,
      to: filterTo || undefined,
      contractNumber: filterContract || undefined,
    }

    this.props.startTransaction(() =>
      SaleAttributionService.getPendingSaleAttributions(payload).then(response => {
        const raw = response.data.sales_pending || []
        // Deduplicate by id to guard against API returning duplicate rows
        const seen = new Set()
        const pendingAttributions = raw.filter(item => {
          if (seen.has(item.id)) return false
          seen.add(item.id)
          return true
        })
        const pagination = response.data.pagination
        this.props.savePendingAttributions(pendingAttributions, pagination)
        this.fetchGroupUsers(payload)
      })
    )
  }

  preparePayload(id, userId) {
    const { user, campaign } = this.props
    return { clientSlug: user.client.slug, campaignSlug: campaign.slug, id, userId }
  }

  handleUpdateSaleAttribution = (saleId, userId) => {
    const payload = this.preparePayload(saleId, userId)
    this.props.startTransaction(() =>
      SaleAttributionService.updateSaleAttribution(payload)
        .then(response => {
          if (response.data.success) {
            ToastService.success(response.data.message)
            // Re-fetch the pending list so the just-assigned row disappears from
            // the table immediately rather than relying on the Redux mutation
            // (which only updates local state and may not trigger a re-render).
            this.getPendingSaleAttributions()
          } else {
            ToastService.error(response.data.error)
          }
        })
        .catch(error => {
          ToastService.error(error.response.data.error)
        })
    )
    this.unToggleAcceptModal()
  }

  fetchGroupUsers(payload) {
    GroupPositionUserService.getGroupUsers(payload)
      .then(response => {
        this.setState({ users: response.data.users })
      })
      .catch(error => {
        if (error) ToastService.error(error.response.data.error)
      })
  }

  componentDidMount() {
    this.getPendingSaleAttributions()
  }

  componentDidUpdate(prevProps) {
    const { filterFrom, filterTo, filterContract } = this.props
    if (
      prevProps.filterFrom !== filterFrom ||
      prevProps.filterTo !== filterTo ||
      prevProps.filterContract !== filterContract
    ) {
      this.setState({ page: 1 }, () => this.getPendingSaleAttributions())
    }
  }

  toggleAcceptModal = (saleAttribution, selectedUser) => {
    if (saleAttribution.processing) {
      ToastService.error("O registo já está em processamento")
      return
    }
    if (selectedUser === undefined) {
      ToastService.error("Escolha um utilizador")
      return
    }
    this.setState({ isAttributionSelected: true, saleAttribution, selectedUser })
  }

  unToggleAcceptModal = () => {
    this.setState({ isAttributionSelected: false, saleAttribution: undefined })
  }

  render() {
    const { component: Component, ...rest } = this.props
    return (
      <Component
        {...rest}
        {...this.state}
        onUpdateSaleAttribution={this.handleUpdateSaleAttribution}
        onCancelSaleAttribution={this.unToggleAcceptModal}
        onToggleAcceptModal={this.toggleAcceptModal}
        onPageChange={this.handlePageChange}
      />
    )
  }
}

const mapStateToProps = state => ({
  user: state.userReducer.user,
  campaign: state.campaignReducer.campaign,
  pendingSaleAttributions: state.saleAttributionReducer.pendingSaleAttributions,
  pendingPagination: state.saleAttributionReducer.pendingPagination
})

const mapDispatchToProps = dispatch => ({
  savePendingAttributions: (pendingAttributions, pagination) => dispatch(savePendingAttributions(pendingAttributions, pagination)),
  startTransaction: buildTransaction(dispatch)
})

const Container = connect(mapStateToProps, mapDispatchToProps)(PendingAttributionsContainer)

export function withPendingAttributionsContainer(component) {
  return (props) => <Container component={component} {...props} />
}

export default Container
